module.exports = __webpack_public_path__ + "img/featureTreeSalmon.9179520a.png";